const translations = {
    firstNameBodyText: 'Please enter your name',
    firstNameFooterText: 'We need this so that your colleagues can refer to you',
    firstNamePlaceholder: 'First name',
    lastNameBodyText: 'Have a last name?',
    lastNameFooterText: 'We need this so that your colleagues can refer to you',
    lastNamePlaceholder: 'Last name',
    phoneBodyText: "And what's your phone number?",
    phoneFooterText: 'We need this in case of a billing issue',
    phonePlaceholder: 'Phone number',
    welcome: 'Welcome to Exedy.'
};

export default translations;
